var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"build",class:{ buildMove: _vm.buildMoveNum != 0 }},_vm._l((_vm.imgSrc),function(item,index){return _c('img',{key:item,style:({ left: _vm.move_left / (index + 1) + 'px' }),attrs:{"alt":"","src":item}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }